<template>
    <Main>
        <el-row :gutter="20" class="search-table">
            <el-col :span="14" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="keySearch" @keydown.enter="handleSearchData" @search="handleSearchData" :placeholder="$t('dataLinkMulti.valueSearch')"></InputSearch>
            </el-col>
        </el-row>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel" class="table-list-share">
            <template #row="{ row, index, page, perPage }">
                <tr :class="{ 'row-disabled': !row.enable }">
                    <td :data-title="$t('textCommon.no')">
                        <div class="col-first">
                            {{ index + 1 + (page - 1) * perPage }}
                        </div>
                    </td>
                    <td class="col-share-name" :data-title="$t('member.shareName')">
                        <div class="col-share-name__text">{{ row.link_name ? row.link_name : '' }}</div>
                    </td>
                    <td class="col-space" :data-title="$t('dataLinkMulti.app')">
                        {{ row.app_name ? row.app_name : '' }}
                    </td>
                    <td class="col-space" :data-title="$t('dataLinkMulti.view')">
                        {{ row['view_name'] || '' }}
                    </td>
                    <td class="col-filter" :data-title="$t('dataLinkMulti.filterData')">
                        <div>
                            <div v-for="(item, indexF) in getFilters(row)" :key="indexF" class="filter-content" v-html="item"></div>
                        </div>
                    </td>
                    <td class="col-filter" :data-title="$t('dataLinkMulti.filterUser')">
                        <div>
                            <div class="filter-content" v-html="getFilterMulti(row?.setting, row?.condition_setting)"></div>
                        </div>
                    </td>
                    <td class="text-left text-sm-center col-created" :data-title="$t('member.updated_at')">
                        <FormatDate format="YYYY/MM/DD HH:mm:DD" :date="row.updated_at"></FormatDate>
                    </td>
                    <td class="text-left text-sm-center col-created" :data-title="$t('member.created_at')">
                        <FormatDate format="YYYY/MM/DD HH:mm:DD" :date="row.created_at"></FormatDate>
                    </td>
                    <div class="d-flex justify-content-around flex-wrap fixed-right">
                        <Button classes="btn-xs mr-2 " type="outline-primary" :disabled="isLoading || !row.enable" @click="handleViewDataLink(row)">
                            <el-icon class="el-icon-document"></el-icon>
                            {{ $t('button.detail') }}
                        </Button>
                        <Button classes="btn-xs mr-2" type="info" :disabled="isLoading || !row.enable" @click="handleGoEdit(row)">
                            <el-icon class="el-icon-edit"></el-icon>
                            {{ $t('button.edit') }}
                        </Button>
                        <Button :disabled="isLoading || !row.enable" classes="btn-xs mr-2" type="success" @click="updateDataLinkJob(row)">
                            <el-icon class="el-icon-set-up"></el-icon>
                            {{ $t('dataLinkMulti.updateShare') }}
                        </Button>
                        <Button :disabled="isLoading" classes="btn-xs mr-2 " type="warning" @click="changeStatusConfirm(row)">
                            <el-icon class="el-icon-set-up"></el-icon>
                            {{ !row.enable ? $t('button.active') : $t('button.deactive') }}
                        </Button>
                        <Button classes="btn-xs mr-2" :disabled="isLoading || !row.enable" @click="handleDeleteConfirm(row)" type="danger">
                            <el-icon class="el-icon-delete"></el-icon>
                            {{ $t('button.delete') }}</Button
                        >
                    </div>
                    <td :data-title="''" class="col-action text-sm-center text-left fix-right_mb">
                        <div class="d-flex flex-wrap">
                            <Button :disabled="isLoading || !row.enable" classes="btn-xs px-2 mr-2 mb-2 mr-sm-0" type="outline-primary" @click="handleViewDataLink(row)">
                                <el-icon class="el-icon-document"></el-icon>
                                {{ $t('button.detail') }}
                            </Button>
                            <Button :disabled="isLoading || !row.enable" classes="btn-xs px-2 mr-2 mb-2 mr-sm-0" type="info" @click="handleGoEdit(row)">
                                <el-icon class="el-icon-edit"></el-icon>
                                {{ $t('button.edit') }}
                            </Button>
                            <Button :disabled="isLoading || !row.enable" classes="btn-xs px-2 mr-2 mb-2 mr-sm-0" type="success" @click="updateDataLinkJob(row)">
                                <el-icon class="el-icon-set-up"></el-icon>
                                {{ $t('dataLinkMulti.updateShare') }}
                            </Button>
                            <Button :disabled="isLoading" classes="btn-xs px-2 mr-2 mb-2 mr-sm-0" type="warning" @click="changeStatusConfirm(row)">
                                <el-icon class="el-icon-set-up"></el-icon>
                                {{ !row.enable ? $t('button.active') : $t('button.deactive') }}
                            </Button>
                            <Button :disabled="isLoading || !row.enable" classes="btn-xs px-2 mr-2 mb-2 mr-sm-0" @click="handleDeleteConfirm(row)" type="danger">
                                <el-icon class="el-icon-delete"></el-icon>
                                {{ $t('button.delete') }}</Button
                            >
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import InputSearch from '@/components/partials/customs/InputSearch';
import Button from '@/components/partials/Button';
import FormatDate from '@/components/partials/FormatDate';
import { mapState } from 'vuex';
export default {
    name: 'ShareListMulti',
    components: {
        TableBox,
        Main,
        InputSearch,
        Button,
        FormatDate
    },
    data: function () {
        return {
            isLoading: false,
            config: {
                q: '',
                action: 'dataLinkMulti/list',
                headers: [
                    {
                        label: 'textCommon.no'
                    },
                    {
                        sort: 'link_name',
                        label: 'share.shareName'
                    },
                    {
                        sort: 'app_name',
                        label: 'dataLinkMulti.app'
                    },
                    {
                        label: 'dataLinkMulti.view'
                    },
                    {
                        label: 'dataLinkMulti.filterData'
                    },
                    {
                        label: 'dataLinkMulti.filterUser'
                    },
                    {
                        sort: 'updated_at',
                        label: 'member.updated_at'
                    },
                    {
                        sort: 'created_at',
                        label: 'member.created_at'
                    },
                    {
                        label: ''
                    }
                ],
                sort: {
                    field: 'updated_at',
                    order: 'desc'
                }
            },
            isReload: false,
            keySearch: null,
            dataList: []
        };
    },
    created() {},
    watch: {},
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    methods: {
        getFilterMulti(item, conditionSetting) {
            let dataReturn = [];
            const condition = conditionSetting?.toLowerCase() === 'or' ? 'または' : 'と';
            item.forEach((element) => {
                if (element.condition_type.includes('=')) {
                    dataReturn.push(element.field_name + this.$t('filter.condition1') + element.user_field_name);
                }
            });
            return dataReturn.join(`<strong>${condition}</strong> </br>`);
        },
        handleGoEdit(row) {
            this.$router.push({
                name: 'editDataLinkMulti',
                query: {
                    id: row.id,
                    typeShare: 'form-multi-filter'
                }
            });
        },

        handleViewDataLink(row) {
            this.$router.push({
                name: 'viewDataLinkMulti',
                query: { id: row.id }
            });
        },

        handleDeleteConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('share.msgDeleteShareConfirm'),
                callback: () => {
                    this.deleteCallback(row);
                }
            });
        },

        changeStatusConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: !row.enable ? this.$t('share.msgActiveShareConfirm') : this.$t('share.msgDeActiveShareConfirm'),
                callback: () => {
                    this.changStatusCallback(row);
                }
            });
        },

        updateDataLinkJob(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('dataLinkMulti.confirmUpdateShare'),
                callback: () => {
                    this.updateJob(row);
                }
            });
        },

        updateJob(row) {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: this.$t('dataLinkMulti.updateShareSuccess')
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('dataLinkMulti/update_job', payload);
        },

        changStatusCallback(row) {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                this.isReload = !this.isReload;
                let message = !row.enable ? this.$t('share.msgActiveShareSuccess') : this.$t('share.msgDeactiveShareSuccess');
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: message
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isReload = !this.isReload;
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                data: {
                    status: !row.enable
                },
                id: row.id
            };
            this.$store.dispatch('dataLinkMulti/toogle_status', payload);
        },

        deleteCallback(row) {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    this.isReload = !this.isReload;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgDeleteShareSuccess')
                    });
                }
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isReload = !this.isReload;
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('dataLinkMulti/delete', payload);
        },

        getFilters(row) {
            let result = [];
            if (row && row['array_filter']) {
                if (row['array_filter'].length > 0) {
                    if (row['data_filter']) {
                        let query = row['array_filter'][0].query ? row['array_filter'][0].query : '';
                        let typeFilter = row['data_filter'].includes(' or ') ? ' or ' : ' and ';
                        let arrayData = query.split(typeFilter);

                        if (arrayData && arrayData.length > 0) {
                            arrayData.map((elm, index) => {
                                if (index < arrayData.length - 1) {
                                    result.push(elm + `<strong>${typeFilter}</strong>`);
                                } else {
                                    result.push(elm);
                                }
                            });
                        }
                    } else {
                        result.push(this.$t('filter.allRecord'));
                    }
                } else {
                    result.push(this.$t('filter.allRecord'));
                }
            }
            return result;
        },

        handleSearchData() {
            this.config.q = this.keySearch ? this.keySearch.toString().trim() : '';
            this.config = Object.assign({}, this.config);
        },
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.config.q = e.search;
            this.keySearch = e.search;
        }
    }
};
</script>
